import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { CONFIRMACAO_ENTREGAS_BASE_ROUTES } from './confirmacao-entregas-base.routes';
import { addRoutesWhenAnyFeatureEnabled } from '../../shared/routes/feature-routes.util';

export const CONFIRMACAO_ENTREGAS_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    addRoutesWhenAnyFeatureEnabled(
      routesService,
      configState,
      ['cargo_fleet.ConfirmacaoEntregas'],
      [...CONFIRMACAO_ENTREGAS_BASE_ROUTES],
    );
  };
}
